import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getPOPunchs = async () => {
    try {
        let data = {}
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/`, data);
        return await response.data;
    } catch (error) {
        console.log("getPOPunchsData - error", error)
        return handleApiError(error)
    }
}

export const submitPOPunch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/submit`, data);
        return await response.data;
    } catch (error) {
        console.log("submitPOPunch - error", error)
        return handleApiError(error)
    }
}

export const getPOPunchByBuyerPOId = async (buyerPOId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po-punch/${buyerPOId}`);
        return await response.data;
    } catch (error) {
        console.log("getPOPunchByBuyerPOId - error", error)
        return handleApiError(error)
    }
}

export const getPOPunchByBuyerReqIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/all-po-punch`, data);
        return await response.data;
    } catch (error) {
        console.log("getPOPunchByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const deletePOPunch = async (poPunchId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/delete/${poPunchId}`);
        return await response.data;
    } catch (error) {
        console.log("deletePOPunch - error", error)
        return handleApiError(error)
    }
}

export const getConsumerProducts = async (branchId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-po-punch/consumer_products/${branchId}`);
        return await response.data;
    } catch (error) {
        console.log("getConsumerProducts - error", error)
        return handleApiError(error)
    }
}

export const placeConsumerOrder = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/consumer_order`, data);
        return await response.data;
    } catch (error) {
        console.log("placeConsumerOrder - error", error)
        return handleApiError(error)
    }
}

export const getPOPunchOrderDetailsByBuyerPOIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/order-details/buyer-po-ids`, data);
        return await response.data;
    } catch (error) {
        console.log("getPOPunchOrderDetailsByBuyerPOIds - error", error)
        return handleApiError(error)
    }
}

export const getPoRescheduleReasonList = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-po-punch/reschedule-reason`, data);
        return await response.data;
    } catch (error) {
        console.log("getPoRescheduleReasonList - error", error)
        return handleApiError(error)
    }
}